import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ProductDetails() {
    const location = useLocation();
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
    const data = location.state;

  return (
    <div className="h-hit w-full py-12 md:py-24">
        <div className="mxw">
            <div className="max-w-6xl mx-auto grid grid-cols-4 items-center gap-8 md:gap-12">
                <div className="col-span-2 h-40 md:h-96">
                    <img className="w-full h-full object-cover" src={data?.img} alt="" />
                </div>
                <div className="col-span-2 space-y-2 py-4 md:py-0">
                    <p className="font-medium text-xl md:text-2xl capitalize">{data?.name}</p>
                    <p className="text-gray-500 capitalize">{data?.type}</p>
                    <div className="w-full">
                        <p className="text-xl md:text-2xl font-bold">${data?.price}</p>
                    </div>
                </div>
            </div> 
            <section className="py-12 max-w-6xl mx-auto space-y-4">
                <div className="">
                    <p className="pb-2 text-xl md:text-2xl font-bold">Let's talk about the <span className="capitalize">{data?.name}</span></p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit nostrum nihil, saepe minus totam quam maxime dolores hic iure impedit incidunt dicta officia nulla illo neque consectetur distinctio pariatur adipisci. Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                </div>
                <div className="">
                    <p className="pb-2 text-xl md:text-2xl font-bold">Signature Details</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit nostrum nihil, saepe minus totam quam maxime dolores hic iure impedit incidunt dicta officia nulla illo neque consectetur distinctio pariatur adipisci.</p>
                </div>
                <div className="">
                    <p className="pb-2 text-xl md:text-2xl font-bold">Lightweight</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit nostrum nihil, saepe minus totam quam maxime dolores hic iure impedit incidunt dicta officia nulla illo neque consectetur distinctio pariatur adipisci.</p>
                </div>
                <div className="">
                    <p className="pb-2 text-xl md:text-2xl font-bold">Product Details</p>
                    <ul className="list-disc list-inside text-gray-600 font-medium">
                        <li>Standard fit for a comfortable fit</li>
                        <li>Excellent quality and materials for long-ter durability</li>
                        <li>100% cotton</li>
                        <li>Machine Wash</li>
                        <li>Imported</li>
                    </ul>
                </div>
            </section>
        </div>
    </div>
  )
}
